import { camelCase } from "lodash";
import { LokiSalesController } from "../sales/loki-sales.controller";
import { PremiumStatus } from "../../typings/common";

export class LokiItemsController extends LokiSalesController {
    public static $inject: string[] = [
        "$mdDialog",
        "$q",
        "$scope",
        "$state",
        "$translate",
        "$window",
        "configService",
        "liveService",
        "lokiFilterService",
        "mediaGalleryService",
        "onlineDateService",
        "organizationService",
        "sitesService",
        "toaster"
    ];

    public context: string;
    public items: any = [];
    public itemsTotal: number;
    public hasMoreItems: boolean;
    public resultLimit: number;

    constructor(
        $mdDialog: ng.material.IDialogService,
        $q: ng.IQService,
        protected $scope: ng.IScope,
        protected $state: ng.ui.IStateService,
        $translate,
        $window: ng.IWindowService,
        configService,
        liveService,
        protected lokiFilterService,
        private mediaGalleryService,
        onlineDateService,
        organizationService,
        sitesService,
        toaster
    ) {
        super(
            $mdDialog,
            $q,
            $scope,
            $state,
            $translate,
            $window,
            configService,
            liveService,
            lokiFilterService,
            onlineDateService,
            organizationService,
            sitesService,
            toaster
        );
    }

    public $onInit() {
        this.context = this.$state.current.data.context;
        const contextKey = camelCase(`${this.context}-items`);

        this.$scope.$watchCollection(
            () => this.lokiFilterService[contextKey],
            () => {
                this.items = this.lokiFilterService[contextKey]?.items;
                this.itemsTotal = this.lokiFilterService[contextKey]?.total;
                this.hasMoreItems = this.lokiFilterService[contextKey]?.moreResults;
            }
        );
    }

    public showGallery(item) {
        this.mediaGalleryService.open(item, "item-infos");
    }

    public getPremiumIcon(status) {
        switch (status) {
            case PremiumStatus.Confirmed:
                return "check-decagram";
            case PremiumStatus.Refused:
               return "close";
            case PremiumStatus.Pending:
               return "account-eye";
        }
    }
}
